import Routable from '../../mixins/routable'
import Toggleable from '../../mixins/toggleable'

export default {
  name: 'list-tile',

  mixins: [Routable, Toggleable],

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    selectable: Boolean, // list-tile's <list-tile-content> will contain a radio/checkbox as its main content
    disabled: Boolean,
    interactive: { type: Boolean, default: true },
    highlight: Boolean,
  },

  computed: {
    classes () {
      return {
        'list__tile': true,
        'list__tile--active': this.isActive,
        'list__tile--disabled': this.disabled,
        'list__tile--selectable': this.selectable,
        'list__tile--not-interactive': !this.interactive,
        'list__tile--highlight': this.highlight,
      }
    }
  },

  render (h) {
    const { tag, data } = this.generateRouteLink()
    return h(tag, data, [this.$slots.default])
  }
}